<template>
  <div class="charges">
    <template v-if="isLoading">
      <c-row>
        <c-col>
          <h4 class="text-h6">Getting charges...</h4>
        </c-col>
      </c-row>
    </template>
    <template v-else>
      <c-row class="mb-4">
        <c-col>
          <c-button-group class="float-right">
            <c-button v-show="$auth.check('organisation-admin')" color="primary" @click="refreshCharges">
              Refresh
            </c-button>
          </c-button-group>
        </c-col>
      </c-row>
      <c-row>
        <c-col>
          <c-card>
            <c-card-body>
              <c-data-table
                :items="charges"
                :fields="fields"
                :table-filter="{ placeholder: 'Find charge', label: ' ' }"
                items-per-page-select
                :items-per-page="20"
                hover
                sorter
                pagination
                responsive
              >
                <template #no-items-view>
                  <p class="text-center p-5 h3">No charges were found matching that search.</p>
                </template>
                <template #merchant="{item}">
                  <td>
                    <router-link :to="{ name: 'assetDetails', params: { clientId: item._id } }">
                      {{ item.merchant.name }}
                    </router-link>
                  </td>
                </template>
                <template #transactionDate="{item}">
                  <td>
                    {{ item.transactionDate | dateFormat }}
                  </td>
                </template>
                <template #billingAmount="{item}">
                  <td class="text-right">
                    {{ (item.billingAmount * -1) | formatAsCurrency }} {{item.billingCurrency}}
                  </td>
                </template>
                <template #reconcile="{item}">
                  <td>
                    <c-select
                        placeholder="Select"
                        :options="assets"
                        @update:value="assign"
                    />
                  </td>
                </template>
              </c-data-table>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';
import { getCompanyId } from '@/libs/user/getCompanyId';
import CreateAsset from '../components/asset/create.vue';
import { dateFormatNoTime, formatAsCurrency } from '@/filters';

export default {
  name: 'ChargeList',
  data() {
    return {
      showCreate: false,
      isLoading: true,
      charges: [],
      assets: [],
      organisationId: null,
      fields: [
        { key: 'transactionDate', label: 'Date' },
        { key: 'status', label: 'Status' },
        { key: 'transactionType', label: 'Type' },
        { key: 'merchantName', label: 'Name' },
        { key: 'merchantCountry', label: 'Country' },
        { key: 'billingAmount', label: 'Amount' },
        { key: 'reconcile', label: 'Reconcile' },
      ],
    };
  },
  created() {
    this.organisationId = getCompanyId(this.$store);
    this.fetchData();
    this.getAssets();
  },
  methods: {
    formatAsCurrency,
    dateFormatNoTime,
    getBadge(status) {
      return status ? 'success' : 'secondary';
    },
    clientError(error) {
      this.$store.commit('addErrorMessage', {
        header: 'Error getting charges',
        message: error && error.message ? error.message : 'There was a problem getting your list of charges.',
      });
    },
    assign() {},
    refreshCharges() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint('charge/refresh'))
        .then((response) => {
          this.isLoading = false;
          if (!response.data.success) {
            this.clientError();
          } else {
            this.fetchData();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.clientError(error);
        });
    },
    fetchData() {
      console.log('fetch');
      this.isLoading = true;
      this.$http
        .get(buildEndpoint('charge/list/'))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.charges = response.data.data;
          } else {
            this.clientError();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.clientError(error);
        });
    },
    getAssets() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint('asset/list/'))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.assets = response.data.data.map((asset) => ({
              // eslint-disable-next-line no-underscore-dangle
              value: asset._id,
              label: asset.licenceName,
            }));
            this.assets.unshift({
              value: null,
              label: 'Select asset',
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.clientError(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  margin-bottom: 20px;
}
.no-data {
  p {
    text-align: center;
    padding: 40px;
    font-weight: bold;
  }
}
</style>
